import React from 'react'
import type { GamingIncentivesProps } from '@/features/enrollment'

export default function GamingIncentives({ enrollmentData, updateEnrollmentData, errors }: GamingIncentivesProps) {
  return (
    <>
      {/* Tried to Stop Gaming */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Have you tried to stop or give up gaming? <span className="text-red-500">*</span>
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="triedToStopGaming" 
              value="Yes" 
              checked={enrollmentData.triedToStopGaming === 'Yes'} 
              onChange={() => updateEnrollmentData('triedToStopGaming', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="triedToStopGaming" 
              value="No" 
              checked={enrollmentData.triedToStopGaming === 'No'} 
              onChange={() => updateEnrollmentData('triedToStopGaming', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.triedToStopGaming && (
          <p className="mt-1 text-sm text-red-600">{errors.triedToStopGaming}</p>
        )}
      </div>

      {/* Paid for In-Game Items */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Did you pay for additional items in the video games, such as loot, level up options, rewards, badges, or additional game content? <span className="text-red-500">*</span>
        </label>
        
        {/* Auto-selection indicator */}
        {enrollmentData.paidForInGameItems === 'Yes' && (
          <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Auto-selected:</span>
              <span className="ml-2 text-blue-600 font-semibold">Yes</span>
            </p>
            <p className="text-xs text-blue-600 mt-1">
              You can change this selection using the options below if needed.
            </p>
          </div>
        )}
        
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="paidForInGameItems" 
              value="Yes" 
              checked={enrollmentData.paidForInGameItems === 'Yes'} 
              onChange={() => updateEnrollmentData('paidForInGameItems', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="paidForInGameItems" 
              value="No" 
              checked={enrollmentData.paidForInGameItems === 'No'} 
              onChange={() => updateEnrollmentData('paidForInGameItems', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="paidForInGameItems" 
              value="Unsure" 
              checked={enrollmentData.paidForInGameItems === 'Unsure'} 
              onChange={() => updateEnrollmentData('paidForInGameItems', 'Unsure')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Unsure</span>
          </label>
        </div>
        {errors.paidForInGameItems && (
          <p className="mt-1 text-sm text-red-600">{errors.paidForInGameItems}</p>
        )}
      </div>

      {/* Sold In-Game Content */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Did you sell in video game content or loot (level, persons, badges, etc.) for money? <span className="text-red-500">*</span>
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="soldInGameContent" 
              value="Yes" 
              checked={enrollmentData.soldInGameContent === 'Yes'} 
              onChange={() => updateEnrollmentData('soldInGameContent', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="soldInGameContent" 
              value="No" 
              checked={enrollmentData.soldInGameContent === 'No'} 
              onChange={() => updateEnrollmentData('soldInGameContent', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.soldInGameContent && (
          <p className="mt-1 text-sm text-red-600">{errors.soldInGameContent}</p>
        )}
      </div>

      {/* Energy Drink Reward */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Did you receive a reward of an energy drink or powder with Battle Pass or other video games? <span className="text-red-500">*</span>
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivedEnergyDrinkReward" 
              value="Yes" 
              checked={enrollmentData.receivedEnergyDrinkReward === 'Yes'} 
              onChange={() => updateEnrollmentData('receivedEnergyDrinkReward', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivedEnergyDrinkReward" 
              value="No" 
              checked={enrollmentData.receivedEnergyDrinkReward === 'No'} 
              onChange={() => updateEnrollmentData('receivedEnergyDrinkReward', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="receivedEnergyDrinkReward" 
              value="Do not know" 
              checked={enrollmentData.receivedEnergyDrinkReward === 'Do not know'} 
              onChange={() => updateEnrollmentData('receivedEnergyDrinkReward', 'Do not know')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Do not know</span>
          </label>
        </div>
        {errors.receivedEnergyDrinkReward && (
          <p className="mt-1 text-sm text-red-600">{errors.receivedEnergyDrinkReward}</p>
        )}
      </div>

      {/* Gaming Influencers */}
      <div>
        <label className="block text-sm font-medium text-accent-900 mb-2">
          Have you ever watched social media gaming influencers on YouTube, TikTok, or any other websites? <span className="text-red-500">*</span>
        </label>
        
        {/* Auto-selection indicator */}
        {enrollmentData.watchedGamingInfluencers === 'Yes' && (
          <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Auto-selected:</span>
              <span className="ml-2 text-blue-600 font-semibold">Yes</span>
            </p>
            <p className="text-xs text-blue-600 mt-1">
              You can change this selection using the options below if needed.
            </p>
          </div>
        )}
        
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="watchedGamingInfluencers" 
              value="Yes" 
              checked={enrollmentData.watchedGamingInfluencers === 'Yes'} 
              onChange={() => updateEnrollmentData('watchedGamingInfluencers', 'Yes')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="watchedGamingInfluencers" 
              value="No" 
              checked={enrollmentData.watchedGamingInfluencers === 'No'} 
              onChange={() => updateEnrollmentData('watchedGamingInfluencers', 'No')} 
              className="form-radio text-primary-600" 
            />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        {errors.watchedGamingInfluencers && (
          <p className="mt-1 text-sm text-red-600">{errors.watchedGamingInfluencers}</p>
        )}
      </div>
    </>
  )
}